import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function CaseFinancialsRoute() {
  return <AdminOperationsScreen screenIdOverride="financials" />;
}
